import { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { PLATFORM_LEGAL_CORPORATION_LABEL } from 'services/api/constants';
import { useIntlByKey } from 'services/i18n/hooks/useIntlByKey';

// Type assertion to work around react-helmet types incompatibility with React 18
const HelmetComponent = Helmet as unknown as FunctionComponent<{ children: React.ReactNode }>;

export const AppHelmet: FunctionComponent = () => {
  const appHelmetIntl = useIntlByKey('app.helmet');

  return (
    <HelmetComponent>
      <title>
        {appHelmetIntl('title', { legalCorporationLabel: PLATFORM_LEGAL_CORPORATION_LABEL })}
      </title>
      <meta
        name="description"
        content={appHelmetIntl('description', {
          legalCorporationLabel: PLATFORM_LEGAL_CORPORATION_LABEL,
        })}
      />
    </HelmetComponent>
  );
};
